<template>
  <div class="my-main-content">
    <el-row type="flex" justify="center" align="middle" style="min-height: calc(100vh - 108px);">
      <el-col :sm="12" :xs="24">
        <img style="height:10vh" src="../../public/favicon.png" />

        <div>
          <img src="../../public/logo_text_en.png" />
          <img src="../../public/logo_text_cn.png" />
        </div>

        <h2 style="color: antiquewhite;line-height: 10px;">{{ $t("welcome") }}</h2>

        <div @click="$routerTo('/Scan')" class="square-img" style="text-align:left;padding-bottom: 60%;cursor: pointer">
          <img src="../../src/assets/img/scan qr code_2048910.png" style="object-fit: contain;" />
        </div>

        <h4 @click="$routerTo('/Scan')" style="color: antiquewhite;cursor: pointer">{{ $t("scan_qrcode") }}</h4>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("set_page", location.hash);
  },
  methods: {}
};
</script>

<style scoped>
.aaa {
  background-image: url("../../public/images/bg_2.jpeg");
  min-height: calc(100vh - 108px);
  background-size: cover;
  position: relative;
}
.aaa::after {
  position: absolute;
  background: inherit;
  filter: blur(2px);
}

.bg {
  width: 100%;
  min-height: calc(100vh - 108px);
  position: relative;
  background: url("../../public/images/bg_2.jpeg");
  background-size: contain;
  padding: 1px;
  box-sizing: border-box;
  z-index: 1;
}
.bg:after {
  content: "";
  width: 100%;
  min-height: calc(100vh - 108px);
  position: absolute;
  left: 0;
  top: 0;
  background: inherit;
  /* filter: blur(2px); */
  z-index: 2;
}
</style>
